<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 42"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: row
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: row
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            :disabled="row.optionStatus === 'N'"
            v-if="allow('D')"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.optionCode)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      type: Object,
      default: () => {}
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'metadataType',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_metadata_type') || '属性类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'optionName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_option_name') || '备选项名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'optionNameEn',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_option_name_en') || '备选项名称英文',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'optionFullName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title:
            this.$l('table_label_option_full_name') || '备选项完整显示文字',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'optionFullNameEn',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          title:
            this.$l('table_label_option_full_name_en') ||
            '备选项完整显示文字英文',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
      ]
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '确认要删除该记录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$api
            .sampleMetadataOptionsDelApi({ optionCode: code })
            .then((res) => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || res.msg,
                type: 'success'
              })
              this.$emit('reload')
            })
        })
        .catch(() => {})
    }
  }
}
</script>
